
export const FETCH_NEWS = 'FETCH_NEWS';
export const SUCCESS_NEWS = 'SUCCESS_NEWS';
export const LOADING_NEWS = 'LOADING_NEWS'
export const RESET_NEWS = 'RESET_NEWS'

export const FETCH_NEW = 'FETCH_NEW';
export const SUCCESS_NEW = 'SUCCESS_NEW';
export const LOADING_NEW = 'LOADING_NEW'
